import { Box, Typography } from '@mui/material'

type TripBuilderAddButtonProps = {
  label: string
  onClick: () => void
}

const TripBuilderAddButton = ({ label, onClick }: TripBuilderAddButtonProps) => (
  <Box
    onClick={onClick}
    sx={{
      border: '1px dashed',
      borderColor: 'primary.main',
      borderRadius: '6px',
      py: 1,
      px: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      bgcolor: 'common.white',
      '&:hover': {
        bgcolor: 'primary.light',
      },
    }}
  >
    <Typography fontWeight={700} color="primary.main">
      {label}
    </Typography>
  </Box>
)

export default TripBuilderAddButton
